var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PopupContent',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPopup),expression:"showPopup"}],staticClass:"bubble-popup",style:(_vm.popupStyle),attrs:{"popup-details":_vm.activePopupDetails},on:{"updated":_vm.updatePopupCardSize}})
}
var staticRenderFns = []

export { render, staticRenderFns }